<micro-select-combo #sel
              placeholder="SMS Blacklist Type"
              [mode]="mode"
              [(id)]="blacklistType"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched">
</micro-select-combo>
